module.exports = __webpack_public_path__ + "img/68.cd1e9041.png";